import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout/Layout'
// import VueCookies from 'vue-cookies'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Layout',
      redirect: '/terminal',
      component: Layout,
      meta: { auth: true },
      children: [
        {
          path: 'terminal',
          component: () => import('@/views/Terminal/Terminal'),
          meta: { title: '终端管理', auth: true }
        },
        {
          path: 'product',
          component: () => import('@/views/Product/Product'),
          meta: { title: '产品管理', auth: true }
        },
        {
          path: 'firmware',
          component: () => import('@/views/Firmware/Firmware'),
          meta: { title: '固件管理', auth: true }
        },
        {
          path: 'systemAccount',
          component: () => import('@/views/SystemAccount/SystemAccount'),
          meta: { title: '系统账号管理', auth: true }
        },
        {
          path: 'role',
          component: () => import('@/views/Role/Role'),
          meta: { title: '角色管理', auth: true }
        },
        {
          path: 'userFeedback',
          component: () => import('@/views/UserFeedback/UserFeedback'),
          meta: { title: '用户反馈', auth: true }
        },
        {
          path: 'system',
          component: () => import('@/views/System/System'),
          meta: { title: '系统设置', auth: true }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login/Login')
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js